import { setCurrentUser } from './index';
import { UserRole } from './auth.roles';

const DEFAULT_AVATAR =
  'https://images.empoweredconsumerism-static-files.com/avatar/default-avatar.png';

export function defaultAvatarUrl(avatar) {
  if (!avatar || avatar === '' || avatar.indexOf('default-avatar.png') > 0) {
    return DEFAULT_AVATAR;
  }
  return avatar;
}

export function persistLoginSession(responseData, username, options = {}) {
  localStorage.setItem('pVaAcNkPaOgGeItRyEpAeL', responseData.packageType);

  setCurrentUser({
    un: username,
    fname: responseData.fname,
    mname: responseData.mname,
    lname: responseData.lname,
    avatar: defaultAvatarUrl(responseData.avatar),
    role: UserRole.User,
    usid: responseData.usid,
    email: responseData.email,
    address: responseData.address,
    bday: responseData.bday,
    mobile: responseData.mobile
  });

  localStorage.ecmtctoken = responseData.authorization;
  if (responseData.refreshToken) {
    localStorage.ecmtcrefresh = responseData.refreshToken;
  }
  localStorage.ec_current_usid = responseData.usid;

  localStorage.setItem(
    'sXhYoZwAABuCtDoEPFMGA',
    responseData.isShowAutoPMA === true ? 'true' : 'false'
  );
  localStorage.setItem(
    'sXhYoZwAuBsCtDrEiFp',
    responseData.isShowUSTripMonitoringPage === true ? 'true' : 'false'
  );
  localStorage.setItem(
    'sVhAoNwPPOCGPIM1e2n3u',
    responseData.isShowPCPMenu === true ? 'true' : 'false'
  );
  if (options.setShowBibo !== false) {
    localStorage.setItem('oZwAuCtDoAYBEPsXhFMGA', responseData.isShowBibo);
  }
  localStorage.setItem('bibo-only', 'false');
}
